<mat-card>
  <div class="notifications-container">
      <div class="page-heading">
      <button class="mwe-button mwe-button--primary ps-3 pe-3" style="cursor: context-menu;" >All Notifications</button>
    </div>
      <div class="d-flex align-content-center justify-content-between" >
        <div class="d-flex align-content-center justify-content-center gap-2  ">
          <mat-checkbox (change)="selectAllNotifications()" [checked]="selectAll" > {{ (selectAll)? ('Unselect All'): ('Select All') }} </mat-checkbox>
          <button *ngIf="checkedNotificationsList.length !== 0 && selectAll " class="mark-as-read button-primary btn btn-primary" (click)="changeAll('READ')"  >Mark as Read</button>
          <button *ngIf="checkedNotificationsList.length !== 0 && selectAll " class="mark-as-read button-primary btn btn-primary" (click)="changeAll('DELETE')" >Delete</button>
        </div>

        <div class="page-numbers">
          <button mat-icon-button (click)="prevpage()" [disabled]="pageNumber === 0 " >
            <img src="assets/images/pagination_prev.svg" alt="" srcset="">
          </button>
    
          <ng-container>
            <button mat-button>
              {{ pageNumber + 1 }}
            </button>
          </ng-container>
    
          <button mat-icon-button (click)="nextpage()" >
            <img src="assets/images/pagination_next.svg" alt="" srcset="">
          </button>
        </div>
      </div>
      <div class="tab-header">
        <div class="tab" [class.active]="activeTab === 0" (click)="selectTab(0)">ALL</div>
        <div class="tab" [class.active]="activeTab === 1" (click)="selectTab(1)">READ</div>
        <div class="tab" [class.active]="activeTab === 2" (click)="selectTab(2)">UNREAD</div>
      </div>
      <div *ngIf="allNotifications.length  > 0; else noNotifications">

        <div *ngFor="let notification of allNotifications" [id]="notification.id" class="notification-item" >
          <div class="d-flex align-items-center justify-content-center " >
            <mat-checkbox (change)="checkedNotifications($event, notification)" [checked]="selectAll"></mat-checkbox>
          </div>
          <div class="notification" style="cursor: pointer;">
            <h3 (click)="showContent(notification)"><b>{{ notification.status }}</b></h3>
            <div (click)="showContent(notification)" class="mail-text"><img src="\assets\images\email_4546924.svg" alt=".." height="14px" width="14px" style="margin-top:3px; margin-right:8px;">
              <p ><b>Subject:</b>&nbsp;</p>
              <p  style="margin-bottom: 0px;" [innerHTML]="notification.subject || 'No Subject' "></p>
            </div>
            <p (click)="showContent(notification)" *ngIf="showContentList.includes(notification.id)" style="margin-bottom: 0px;" [innerHTML]="notification.content || 'No Subject' "></p>
            <div class="d-flex"  >
            <span>{{ notification.createdOn | date: 'short' }}</span>
            <div class="d-flex gap-3 align-items-center " >
              <button class="mark-as-read button-primary btn btn-primary" (click)="updateToRead(notification.id)" *ngIf="notification.status === 'UNREAD'">Mark as Read</button>
              <img style="cursor: pointer;" src="../../assets/images/bin.svg" alt="" class="delete-icon" (click)="deleteNotification(notification.id)">
            </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noNotifications>
        <p>No notifications to display.</p>
      </ng-template>
  </div>
</mat-card>